var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3286 10.9395L13.3824 16.6731C13.2616 16.7896 13.1337 16.8732 12.9987 16.9239C12.8637 16.9746 12.7197 17 12.5667 17C12.4136 17 12.2696 16.9746 12.1346 16.9239C11.9997 16.8732 11.8718 16.7896 11.751 16.6731L5.78428 10.9197C5.5583 10.7018 5.44531 10.4363 5.44531 10.1233C5.44531 9.81027 5.5583 9.54479 5.78428 9.32688C6.01027 9.10896 6.28901 9.0033 6.6205 9.0099C6.95197 9.01649 7.2307 9.12874 7.4567 9.34666L12.5667 14.274L17.6971 9.32688C17.9231 9.10896 18.195 9 18.5129 9C18.8307 9 19.1026 9.10896 19.3286 9.32688C19.5545 9.54479 19.6675 9.81356 19.6675 10.1332C19.6675 10.4528 19.5545 10.7216 19.3286 10.9395Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.a70b90ee.svg";
export { ForwardRef as ReactComponent };